import React from 'react'
import cn from 'classnames'
import styles from './floating-filter-icon.module.scss'
import FilterIcon from 'components/filters/FilterIcon'
import UserIcon from 'components/users/UserIcon'
import { PanelState } from 'state/PanelState'
import { getCachedQuest } from 'state/cache'
import { Filter } from 'components/filters/useStreamFilters'
import { streamOrderConfigs, getFilterMapping } from './StreamOrder'

interface FloatingFilterIconProps {
    panel: PanelState
    onScrollToTop: () => void
}

// Function to get the appropriate icon class based on filter and mapping
const getStreamOrderIconClass = (filter: Filter | undefined | null): string | undefined => {
    if (filter?.history || filter?.notifications || filter?.starred) return

    const filterMapping = getFilterMapping(filter)
    const defaultOrderKey = Object.keys(filterMapping)[0]
    const currentOrderKey = filter?.order || defaultOrderKey

    // Special case for relevance based on query
    if (filter?.query) {
        return streamOrderConfigs.relevance.icon
    }

    // Find the config for the current order key
    const currentOrderConfig = filterMapping[currentOrderKey]

    return currentOrderConfig?.icon
}

export default function FloatingFilterIcon({ panel, onScrollToTop }: FloatingFilterIconProps) {
    const quest = panel.filter?.questId ? getCachedQuest(panel.filter.questId) : null
    const parentUser = quest?.parent?.user
    const streamOrderIconClass = getStreamOrderIconClass(panel.filter)

    return (
        <div
            className={cn(styles.floatingFilterComp, parentUser && styles.thread)}
            onClick={onScrollToTop}
        >
            {!parentUser && streamOrderIconClass && (
                <div className={styles.streamOrderIconContainer}>
                    <i className={cn(streamOrderIconClass, styles.streamOrderIcon)} />
                </div>
            )}

            <FilterIcon
                disable={true}
                filter={panel.filter}
                panel={panel}
                user={gon?.currentUser}
                contextStyles={cn(styles.filterIcon, !parentUser && styles.filterIconSingle)}
                fontIcon={styles.fontIcon}
                privateIcon={styles.privateIcon}
                notiIcon={styles.notiIcon}
                publicIcon={styles.publicIcon}
                allIcon={styles.allIcon}
                historyIcon={styles.historyIcon}
                hodlockerIcon={styles.hodlockerIcon}
                twetchIcon={styles.twetchIcon}
                type="control"
                showNumNoti
            />
            {parentUser && (
                <UserIcon user={parentUser} contextStyles={styles.userIcon} size="small" />
            )}
        </div>
    )
}
